import { PageHeader } from "antd";
import Search from "antd/lib/input/Search";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import ArchiveSwitch from "Components/archive-switch";
import { createComponentStore, useStoreState } from "easy-peasy";
import React, { useEffect, useState } from "react";
import {
  PartnerStoreModel,
  ACTION_TYPES,
} from "store/models/master-data/partner";
import { isScreenMobile, sort } from "Utils";
import PartnersList from "./components/list";
import NewPartnerButton from "./components/new-button";
import PartnersTable from "./components/table";

const usePartnerStore = createComponentStore(PartnerStoreModel);

export default function PartnersPage({ ...props }) {
  const { abilities } = useStoreState((store) => store.auth);
  const [filteredValue, setFilteredValue] = useState({});
  const [data, setData] = useState([]);
  const [store, actions] = usePartnerStore();
  const { setShowArchived } = actions;
  const IsAuthorized = AuthCheck(abilities, AUTH_ACTIONS.READ, "Muhataplar");

  const fetch = () => {
    store.showArchived ? actions.fetchDeletedRecords() : actions.fetch();
  };

  useEffect(() => {
    if (
      filteredValue.fastSearchParam &&
      filteredValue.fastSearchParam.length > 0
    ) {
      let value = filteredValue.fastSearchParam.toUpperCase();
      let data = [...store.data].filter((f) => {
        return (
          f.code.toUpperCase().indexOf(value) !== -1 ||
          ((f.name || f.surname) &&
            (f.name?.toUpperCase() + " " + f.surname?.toUpperCase()).indexOf(
              value
            ) !== -1) ||
          (f.email && f.email?.toUpperCase().indexOf(value) !== -1) ||
          (f.taxOffice && f.taxOffice?.toUpperCase().indexOf(value) !== -1) ||
          (f.address && f.address?.toUpperCase().indexOf(value) !== -1)
        );
      });
      console.log(data);
      setData(data);
    } else {
      setData(store.data);
    }
  }, [filteredValue]);

  useEffect(() => {
    if (IsAuthorized) fetch();
  }, [store.showArchived, IsAuthorized]);

  useEffect(() => {
    setData(store.data.sort((a, b) => sort(b.createdAt, a.createdAt)));
  }, [store.data]);

  return (
    <>
      <PageHeader
        title="Muhataplar"
        className={
          isScreenMobile() ? "mobile-customized customized" : "customized"
        }
        extra={[
          <ArchiveSwitch
            key="archive"
            onChange={(checked) => setShowArchived(checked)}
            authSubject="Muhataplar"
          />,
          <Search
            disabled={!IsAuthorized}
            key="search"
            style={isScreenMobile() ? {} : { width: "auto" }}
            placeholder="Ara: Kod, Ad, Soyad, Email, Vergi Dairesi"
            allowClear={true}
            onSearch={(value) => {
              if (value.length > 0) {
                setFilteredValue({ ...filteredValue, fastSearchParam: value });
              } else {
                if ("fastSearchParam" in filteredValue)
                  delete filteredValue.fastSearchParam;

                setFilteredValue({ ...filteredValue });
              }
            }}
          />,
          <NewPartnerButton key="new" />,
        ]}
      />
      <div style={{ marginTop: 20 }}>
        {isScreenMobile() ? (
          <PartnersList
            IsAuthorized={IsAuthorized}
            data={data}
            loading={store.process === ACTION_TYPES.FETCHING_DATA}
            onOperationExecuted={() => fetch()}
            onSetFilteredValue={(filters) => {
              setFilteredValue({ ...filteredValue, ...filters });
            }}
          />
        ) : (
          <PartnersTable
            IsAuthorized={IsAuthorized}
            data={data}
            loading={store.process === ACTION_TYPES.FETCHING_DATA}
            onOperationExecuted={() => fetch()}
            filteredValue={filteredValue}
            onSetFilteredValue={(filters) => {
              if (!filters.sort) delete filteredValue.sort;
              setFilteredValue({ ...filteredValue, ...filters });
            }}
          />
        )}
      </div>
    </>
  );
}
